// extracted by mini-css-extract-plugin
export default {"armondOrange":"#FFB21D","armondBlack":"#000000","armondWhite":"#FFFFFF","my3dmodel":"mypage_main_my3dmodel__WQf35","checkmy3dmodel":"mypage_main_checkmy3dmodel__-5FBC"};